import { useState, useEffect } from "react";
import { answeredLessonFillInTheBlankQuestion } from "../../../api/lesson_modules/students";

import "./index.css";

function FillInTheBlankWidget(props) {
  const [userSubmittedAnswer, setUserSubmittedAnswer] = useState(props.user_submitted_answer);

  useEffect(() => {
    setUserSubmittedAnswer(props.user_submitted_answer);
  }, [props.user_submitted_answer])

  function createInput(idx) {
    return (
      <span className="FillInTheBlankEmployeeReaderWidget">
        <input
          type="text"
          onBlur={onSave}
          onChange={(e) => {
            const arr = [...userSubmittedAnswer.answer];
            arr[idx] = e.target.value;
            const newUserSubmittedAnswer = {
              ...userSubmittedAnswer,
              answer: arr,
            }
            setUserSubmittedAnswer(newUserSubmittedAnswer);
          }}
          value={userSubmittedAnswer.answer[idx]}
        />
      </span>
    )
  }

  function renderQuestion() {
    const { question } = props;
    if (question.length === 0) {
      return <></>;
    }

    const html = []
    let i = 0, j = 0, answerIdx = 0, answers, hasFillInTheBlanks = false;
    if (!userSubmittedAnswer.answer) {
      answers = [];
    } else {
      answers = new Array(userSubmittedAnswer.answer.length);
    }
    while (i < question.length) {
      if (i + 2 <= question.length && question[i] === "_" && question[i+1] === "_") {
        hasFillInTheBlanks = true;
        html.push(<span className="questionText">{question.slice(j, i)}</span>);
        html.push(createInput(answerIdx));
        if (userSubmittedAnswer.answer[answerIdx]) {
          answers[answerIdx] = userSubmittedAnswer.answer[answerIdx];
        } else {
          answers[answerIdx] = '';
        }
        answerIdx++;
        i += 2;
        j = i;
        continue;
      }
      i++;
    }

    if (!hasFillInTheBlanks) {
      html.push(<span className="questionText">{question}</span>)
    }

    html.push(<span className="questionText">{question.slice(j, question.length)}</span>);
    return html;
  }

  async function onSave() {
    const body = {
      id: props.lesson_id,
      lesson_fill_in_the_blank_answer: {
        answer: userSubmittedAnswer.answer || [],
        lesson_fill_in_the_blank_module_id: props.id
      }
    }
    await answeredLessonFillInTheBlankQuestion(body);
  }

  return (
    <div className="ReaderWidget FillInTheBlankReaderWidget">
      {/* <div className="FillInTheBlankReaderWidgetHeader">Fill in the blank</div> */}
      {renderQuestion()}
      {/* <div className="FillInTheBlankReaderWidgetSubmit">
        <Button
          onClick={onSave}
          text="Save"
        />
      </div> */}
    </div>
  )
}

export { FillInTheBlankWidget };
